import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Currency from '../Currency';

import './index.css';

const UserInfo = ({ firstName, accountValue, accountNumber }) => (
  <div styleName="userInfo">
    <div styleName="welcomeMessage">{'Welcome, '}<Link styleName="welcomeLink" to={`/account/${accountNumber}`}>{firstName}</Link></div>
    <div styleName="accountInfo">
      <div styleName="filler" />
      <label htmlFor="accountValue" styleName="accountValueLabel">Account Value -</label>
      <Currency id="accountValue" style={{ marginLeft: '6px', fontSize: '18px', color: '#0255a3' }} amount={accountValue} />
    </div>
  </div>
);

UserInfo.propTypes = {
  firstName: PropTypes.string,
  accountValue: PropTypes.number,
  accountNumber: PropTypes.string,
};

UserInfo.defaultProps = {
  firstName: 'Guest',
  accountValue: null,
  accountNumber: 'unknown',
};

export default UserInfo;



// WEBPACK FOOTER //
// ./src/components/Header/UserInfo.js